export const defineDefaultEnumValue = (enumObject, defaultValue) => {
  Object.defineProperty(enumObject, 'DEFAULT', {
    value: defaultValue,
    enumerable: false,
  });
};

/**
 * Create enum clamp function
 * @param {Object} enumObject - enum object
 * @param {T} defaultValue - default enum value
 * @returns {EnumClampFunction<T>} - clamp function
 */
export const createEnumClampFunction = (enumObject, defaultValue = undefined) => {
  const values = Object.values(enumObject);

  return (value, localDefaultValue = undefined) => {
    if (values.includes(value)) {
      return value;
    }

    if (localDefaultValue !== undefined) {
      return localDefaultValue;
    }
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    return values[0];
  };
};

export const defineEnumClampFunction = (enumObject, defaultValue = undefined) => {
  Object.defineProperty(enumObject, 'clamp', {
    value: createEnumClampFunction(enumObject, defaultValue),
    enumerable: false,
  });
};

/**
 * @typedef {Function} EnumClampFunction
 * @template T
 * @param {T|string} value - value of enum
 * @param {T} [localDefaultValue] - default value if "value" is not in enum
 * @returns {T} - clamped value
 */
